var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "direction 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_719_1721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1632",
    d: "M0 3.8147e-06H42V42H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_719_1721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1638",
    d: "M10.7833 9.56844C11.2635 9.49297 11.6216 10.0097 11.3897 10.4109L10.1299 12.5928L13.4769 14.5253M11.6293 17.721L8.28423 15.7897L7.02448 17.9716C6.77888 18.3971 6.13018 18.3042 5.98014 17.8377L3.48885 11.3821C3.36006 11.0479 3.57269 10.6923 3.92411 10.6422M13.4769 27.4746L10.1299 29.407L11.3897 31.5889C11.6353 32.0144 11.2305 32.5296 10.7515 32.4263L3.91509 31.3561C3.56129 31.3005 3.35965 30.9386 3.49197 30.6093L5.99171 24.132C6.16643 23.6785 6.79291 23.6267 7.02448 24.0282L8.28423 26.2101L11.6293 24.2789M22.8457 30.7537V34.6172H25.3652C25.8565 34.6172 26.1003 35.2254 25.7713 35.5885L21.4263 40.9739C21.2012 41.2526 20.7869 41.2462 20.5679 40.967L16.2084 35.5636C15.9029 35.1854 16.1714 34.617 16.6347 34.6172H19.1543V30.7537M30.3706 24.2789L33.7157 26.2101L34.9755 24.0282C35.2211 23.6027 35.8697 23.6957 36.0198 24.1621L38.5111 30.6177C38.6399 30.952 38.4273 31.3075 38.0759 31.3577L31.2166 32.4314C30.7364 32.5068 30.3784 31.9902 30.6103 31.589L31.87 29.407L28.5231 27.4746M28.5231 14.5253L31.87 12.5928L30.6103 10.411C30.3647 9.9854 30.7695 9.47024 31.2484 9.57352L38.0848 10.6437C38.4387 10.6993 38.6403 11.0612 38.508 11.3906L36.0083 17.8678C35.8335 18.3213 35.207 18.3731 34.9755 17.9717L33.7157 15.7897L30.3706 17.721M19.1543 11.2461V7.38263H16.6348C16.1435 7.38263 15.8997 6.77445 16.2286 6.4113L20.5737 1.02595C20.7988 0.74729 21.2131 0.753606 21.432 1.03292L25.7916 6.43632C26.0971 6.8144 25.8286 7.38288 25.3653 7.38263H22.8457V11.2461",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1642",
    d: "M21 30.8438C26.4218 30.8438 30.8438 26.4217 30.8438 21C30.8438 15.5782 26.4218 11.1562 21 11.1562C15.5782 11.1562 11.1562 15.5782 11.1562 21C11.1562 26.4217 15.5782 30.8438 21 30.8438Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1646",
    d: "M15.7288 22.4501L16.8889 21.29L20.9492 14.9093L26.7498 20.7099L20.3691 24.7702L19.2091 25.9304C18.571 26.5684 17.527 26.5684 16.8889 25.9304L15.7288 24.7702C15.0907 24.1322 15.0907 23.0881 15.7288 22.4501Z",
    stroke: "#FACA15",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1650",
    d: "M16.8889 21.2899L22.6894 27.0905",
    stroke: "#FACA15",
    strokeWidth: 1.2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1654",
    d: "M7.35303 10.1053H7.3536",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.da2847d07a53ed6c444c2d6bacc6c2e3.svg";
export { ForwardRef as ReactComponent };